import { render } from "./RezepteListeView.vue?vue&type=template&id=789d228e&scoped=true"
import script from "./RezepteListeView.vue?vue&type=script&lang=js"
export * from "./RezepteListeView.vue?vue&type=script&lang=js"

import "./RezepteListeView.vue?vue&type=style&index=0&id=789d228e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789d228e"]])

export default __exports__